import InteractiveVideoPlane from "./InteractiveVideoPlane";

export default function Mokey({
  promptText = "Ver holograma [E]",
  radius = 8,
  scaleMultiplier = 1.5,
  cameraOffset = [0, 2, 6],
  cameraTransitionDuration = 1,
  ...props
}) {
  return (
    <InteractiveVideoPlane
      id="Mokey"
      videoSrc="/video/mokey.webm"
      promptText={promptText}
      radius={radius}
      scaleMultiplier={scaleMultiplier}
      hudText="Hola amigo!"
      cameraOffset={cameraOffset}
      cameraTransitionDuration={cameraTransitionDuration}
      {...props}
    />
  );
}
